module.exports = __webpack_public_path__ + "static/media/bela.bb2340f0.svg";